<template>
    <div class="notFoundPage">
        <p class="text"><span>Oups</span><br/>{{$t('notFound')}}</p>
    </div>
</template>

<script>
export default {
    name: 'NotFound',
    data () {
        return {

        }
    }
}
</script>

<style lang="scss">
    @import './notFound';
</style>



// WEBPACK FOOTER //
// src/components/NotFound/NotFound.vue